import React from 'react';
import { Redirect } from 'react-router-dom';
import { Trans } from 'react-i18next';
import InputText from '../../components/InputText.jsx';
import TranslationText from '../../components/Translation/TranslationText.jsx';
import RimiLogoHeaderButton from '../../components/HeaderComponents/RimiLogoHeaderButton.jsx';
import ConsentLinks from '../../components/Consents/ConsentLinks.jsx';
import { DateInput } from '../../components/DateInput.jsx';
import urlTools from '../../tools/urlTools.jsx';

export function LoginEmailVerificationFlow({ 
  state, 
  initialData,
  onAddEmail, 
  onBirthDateChange, 
  onAddEmailSubmit, 
  onLogout,
  location,
  businessLogin
}) {
  const { 
    showEmailSent, 
    showEnterEmail, 
    emailHint, 
    email, 
    birthDate, 
    error, 
    emailError, 
    birthDateError 
  } = state;

  if (showEnterEmail) {
    return (
      <div className="container">
        <div className="card">
          <header className="card-header">
            <RimiLogoHeaderButton initialData={initialData} />
            <a onClick={onLogout} className="link-button -pointer -with-left-icon">
              <svg enableBackground="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="m15 6-6 6 6 6" fill="none" stroke="#a12971" strokeWidth="2" />
              </svg>
              <TranslationText text="step_back_button_label" />
            </a>
          </header>
          <div className={error ? "card-content" : "card-content no-padding-bottom"}>
            <h1>
              <Trans i18nKey="account_found_but_no_email_page_in_login_title">
                Your My Rimi account is <b>missing e-mail address information</b>
              </Trans>
            </h1>
            <p>
              <TranslationText text="account_found_but_no_email_page_in_login_info" />
            </p>

            <div className="form-group">
              <div className="form-row">
                <div className={!error ? "form-field" : "form-field -has-error"}>
                  <label htmlFor="email" className="form-field__label">
                    <TranslationText text="email_field_label" />
                  </label>
                  <InputText
                    onChange={onAddEmail}
                    prop="email"
                    value={email}
                    className="form-field__input"
                    placeholder="example@gmail.com"
                  />
                </div>
              </div>
              {!businessLogin ? (
                <div className="form-row">
                  <div className={`form-field ${error ? "-has-error" : ""}`}>
                    <label htmlFor="birthDate" className="form-field__label">
                      <TranslationText text="enter_email_birth_date_input_label" />
                    </label>
                    <DateInput
                      initialDateString={birthDate}
                      onChange={onBirthDateChange}
                      errorMessage={emailError || birthDateError}
                    />
                  </div>
                </div>
              ) : (
                <div className="form-row">
                  <div className="sublabel error-msg show">
                    <span>
                      <TranslationText text={emailError} />
                    </span>
                  </div>
                </div>
              )}
            </div>
            <div className="form-button full-width">
              <button className="button" onClick={onAddEmailSubmit}>
                <TranslationText text="account_found_but_no_email_page_in_login_send_link_btn" />
              </button>
            </div>
          </div>
          <footer className="card-footer no-border">
            <div className="footer-text">
              <ConsentLinks business={businessLogin} />
            </div>
          </footer>
        </div>
      </div>
    );
  }

  if (showEmailSent) {
    return (
      <div className="container">
        <div className="card">
          <header className="card-header">
            <RimiLogoHeaderButton initialData={initialData} />
            {emailHint.length > 0 && (
              <a onClick={onLogout} className="link-button -pointer -with-left-icon">
                <svg enableBackground="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="m15 6-6 6 6 6" fill="none" stroke="#a12971" strokeWidth="2" />
                </svg>
                <TranslationText text="step_back_button_label" />
              </a>
            )}
          </header>
          <div className="card-content">
            <div className="email-sent">
              {emailHint.length === 0 ? (
                <Redirect
                  to={{
                    pathname: '/VerificationCodeAddEmail',
                    state: {
                      apiCall: businessLogin 
                        ? urlTools.constructRoute("api/PasswordRecovery/SetEmailB2B")
                        : urlTools.constructRoute("api/PasswordRecovery/SetEmailB2C"),
                      payload: {
                        email: email,
                        birthDate: birthDate
                      },
                      email: email,
                      previousPath: location.pathname,
                      codeSentTo: email
                    }
                  }}
                />
              ) : (
                <>
                  <h1>
                    <TranslationText text="verify_your_email_page_title" />
                  </h1>
                  <p>
                    <TranslationText text="verify_your_email_page_info" />
                  </p>
                  <p>({emailHint})</p>
                </>
              )}
            </div>
          </div>
          {emailHint.length > 0 && (
            <footer className="card-footer no-border">
              <div className="footer-text">
                <ConsentLinks business={businessLogin} />
              </div>
            </footer>
          )}
        </div>
      </div>
    );
  }

  return null;
}